export const build = {
  production: false,
  timeoutSessao: null,
  client_id_gov_br: 'falecomotjmg-hml.tjmg.jus.br',
  redirect_uri_gov_br: 'https://falecomotjmg-hml.tjmg.jus.br/govbr',
  logout_redirect_uri_gov_br: 'https://falecomotjmg-hml.tjmg.jus.br',
  url_acesso_gov_br: 'https://sso.staging.acesso.gov.br'
};
